import {
  Accordion as MuiAccordion,
  AccordionSummary,
  AccordionDetails,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AccordionProps, ACCORDION_CONSTANTS } from './Accordion.props';

export const Accordion = ({ children, header, ...props }: AccordionProps) => {
  return (
    <MuiAccordion {...props}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        {header || ACCORDION_CONSTANTS.EMPTY_HEADER}
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 2 }}>
        <Box className="accordion-content">
          {children || (
            <span style={{ color: 'var(--text-secondary, #666)' }}>
              {ACCORDION_CONSTANTS.NO_CONTENT_AVAILABLE}
            </span>
          )}
        </Box>
      </AccordionDetails>
    </MuiAccordion>
  );
};

export default Accordion;
